import { IEvent } from "../../../../models/Event"
import React from "react";

export const Calendar: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="calendar-container">
            <div className="schedule">
                <h2 className="panel-title">לו״ז האירוע</h2>
                <ul className="info-list">
                    <li><span>תאריך האירוע</span><strong>{event.date}</strong></li>
                    <li><span>הגעה והתכנסות</span><strong>{event.gatheringTime}</strong></li>
                </ul>
                <h3 className="panel-subtitle">לוז זינוקים</h3>
                <div className="table-wrap">
                    <table className="data-table">
                        <thead>
                        <tr>
                            <th>מקצה</th>
                            <th>שעת זינוק</th>
                        </tr>
                        </thead>
                        <tbody>
                        {event.heats.map(heat =>
                            <tr key={heat.description}>
                                <td>{heat.description}</td>
                                <td>{heat.startHeat}</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                <ul className="info-list">
                    <li><span>טקס סיום וחלוקת פרסים</span><strong>{event.ceremonyTime}</strong></li>
                </ul>
            </div>
        </div >
    )
}
